export default __webpack_public_path__ + "static/media/Home2.4f52fdf7.svg";